import type { FC } from "react";
import styled from "@emotion/styled";

import {
  MDSCardSlotName,
  MDSLoadingDots,
  MDSLoadingDotsSize,
  MDSText,
  MDSTextColor,
  MDSTextVariant,
} from "@/mds";

import { CardContainer, ModalCard } from "./shared";

export const InviteLoadingView: FC = () => (
  <CardContainer>
    <ModalCard title="Checking invitation">
      <div slot={MDSCardSlotName.Content}>
        <LoadingContainer>
          <MDSLoadingDots size={MDSLoadingDotsSize.Large} />
          <MDSText variant={MDSTextVariant.ParagraphS} color={MDSTextColor.Secondary}>
            Hang tight while we verify your invitation link.
          </MDSText>
        </LoadingContainer>
      </div>
    </ModalCard>
  </CardContainer>
);

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[4]};
  padding: ${({ theme }) => theme.spacing[3]} 0;
`;
